export default "__VITE_ASSET__BYRrLRuw__"